import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, effect, input } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';

import { SkSpinner3Component } from '../sk-spinners/sk-spinner-3.component';

@Component({
  selector: 'ml-async-result',
  templateUrl: './async-result.component.html',
  standalone: true,
  imports: [AsyncPipe, SkSpinner3Component],
})
export class AsyncResultComponent implements OnDestroy {
  readonly operation = input.required<Observable<unknown>>();
  readonly hide = input(true);
  private _loading: Subject<boolean> = new BehaviorSubject(false);
  private subscription: Subscription;

  isEmpty = false;
  hasResult = false;
  isLoading: Observable<boolean> = this._loading.pipe(debounce((val) => (val ? timer(100) : timer(0))));

  constructor() {
    effect(() => {
      this.cleanUp();
      const operation = this.operation();

      if (!operation) return;

      this._loading.next(true);
      this.subscription = this.operation().subscribe({
        next: (x) => {
          this.loadCompleted(x);
        },
        error: () => {
          this._loading.next(false);
        },
        complete: () => {
          this._loading.next(false);
        },
      });
    });
  }

  loadCompleted(result: unknown) {
    this._loading.next(false);
    if (result && result instanceof Array) {
      this.hasResult = result.length > 0;
      this.isEmpty = result.length === 0;
    } else if (result) {
      this.hasResult = true;
      this.isEmpty = false;
    } else {
      this.hasResult = false;
      this.isEmpty = true;
    }
  }

  ngOnDestroy() {
    this.cleanUp();
  }

  private cleanUp(): void {
    // Cleanup previous subscription
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
